<template>
    <n-card title="Agendamentos" class="p-4">
      <n-upload
      action="https://ifood-api.cwsweb.com.br/v1/agendamento/arquivo"
      name="agendamentos"
      :headers="{
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJtZGVjaGVjaGkiLCJpYXQiOjE3NjEwMDY3NDYsImV4cCI6MTc2MzU5ODc0Nn0.bssRPHWD7Y_J-lQXCA5EZRDWotLBwhm3rFI131IgIcw'
        }"
        :max="1"
        :show-file-list="true"
        :on-finish="onUploadFinish"
        :on-error="onUploadError"
        >
        <n-button type="primary">📤 Enviar Arquivo</n-button>
      </n-upload>
      
      <div class="flex justify-between mb-4">
        <n-button type="primary" @click="mostrarModalNovo">Novo Agendamento</n-button>
        <!--<n-button type="primary" @click="mostrarModalAgendamentos">Carregar agendamentos</n-button>-->
      </div>

      <n-data-table
        :columns="colunas"
        :data="agendamentos"
        :loading="carregando"
        bordered
      />
  
      <n-modal 
        :show="abrirModalNovo" 
        title="Novo Agendamento" 
        preset="dialog" 
        style="width: 800px; height: 500px;"
        @close="abrirModalNovo = false"
      >
        <div class="grid grid-cols-2 gap-4">
          <n-input        v-model:value="cd_agendamento" placeholder="ID Agendamento" label="ID Agendamento" />
          <n-input        v-model:value="nm_responsavel" placeholder="Responsável" label="Responsável" />
          <n-select       v-model:value="cd_status_visita" placeholder="Status da visita" :options="status_visita" label-field="nm_status_visita" value-field="cd_status_visita" filterable />
          <n-select       v-model:value="cd_tipo_loja" placeholder="Tipo de loja" :options="tipos_loja" label-field="nm_tipo_loja" value-field="cd_tipo_loja" filterable />
          <n-select       v-model:value="cd_equipamentos" placeholder="Equipamentos utilizados" :options="equipamentos" label-field="nm_equipamentos" value-field="cd_equipamentos" filterable />
          <n-select       v-model:value="cd_beacon" placeholder="Beacon" :options="beacons" label-field="nm_qrcode" value-field="cd_beacon" filterable />
          <n-date-picker  v-model:value="dt_chamado" placeholder="Data mínima" label="Data mínima"/>
          <n-input        v-model:value="nivel_sinal" placeholder="Nível do sinal" label="Nível do sinal" />
          <n-input        v-model:value="nm_observacoes" placeholder="Observações" label="Observações" :type="'textarea'" />
        </div>
  
        <div class="flex justify-end mt-4 gap-2">
          <n-button @click="mostrarModalNovo">Cancelar</n-button>
          <n-button type="primary" @click="salvarChamado">Salvar</n-button>
        </div>
      </n-modal>

      <n-modal 
        :show="abrirModalLogs" 
        title="Log de Processamento" 
        preset="dialog" 
        style="width: 80%"
        @close="abrirModalLogs = false"
      >
        <div class="log-card">
          <div class="log-item">
            <span class="value">{{ Logs.message }}</span>
          </div>
          <div class="log-item">
            <span class="label">Total:</span>
            <span class="value">{{ Logs.total }}</span>
          </div>
          <div class="log-item">
            <span class="label">Inseridos:</span>
            <span class="value inserted">{{ Logs.inseridos }}</span>
          </div>
          <div class="log-item">
            <span class="label">Ignorados:</span>
            <span class="value ignored" @click="toggleIgnorados">
              {{ Logs.ignorados }} ▼
            </span>
          </div>
          <div v-if="mostrarIgnorados" class="ignored-list">
            <div
              v-for="(item, index) in Logs.lista_ignorados"
              :key="item.cd_agendamento_ignorado"
              class="ignored-item"
            >
              <div class="ignored-header">
                <span>#{{ index + 1 }}</span>
                <span>ID: {{ item.cd_agendamento_ignorado }}</span>
              </div>
              <div class="ignored-text">
                {{ item.nm_string_ignorada.replaceAll(' , ','\n') }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-end mt-4 gap-2">
          <n-button @click="mostrarModalLogs">OK</n-button>
        </div>
      </n-modal>

    </n-card>
  </template>
  
  <script>
  import { useMessage } from "naive-ui"
  import api from "@/api/api"
  
  export default {
    data() {
      return {
        agendamentos: [],
        carregando: false,
        abrirModalNovo: false,
        abrirModalLogs: false,
        mostrarIgnorados: false,
        Logs:[],
        message: useMessage(),
        nm_motivo: "",
        nm_problema: "",
        nm_observacoes: "",
        dt_chamado: null,
        vl_visita_aprovada: "N", // padrão
        cd_tipo_agendamento: 1,  // padrão
        cd_agendamento: null,
        cd_status_visita: null,
        status_visita: [],
        cd_tipo_loja: null,
        tipos_loja: [],
        cd_equipamentos: null,
        equipamentos: [],
        cd_beacon: null,
        beacons: [],
        colunas: [
            { title: "ID do agendamento", key: "cd_agendamento" },
            { title: "ID Loja", key: "id_loja" },
            { title: "Loja", key: "nm_loja" },
            { title: "Marca", key: "nm_marca_loja" },
            { title: "Data Mínima", key: "dt_minima_formatada" },
            { title: "Data Máxima", key: "dt_maxima_formatada" },
            { title: "Status", key: "nm_status_agendamento" },
        ],
        lojas: [],
        visita_aprovada: [
          {
            value: 'S',
            label: 'Sim'
          },
          {
            value: 'N',
            label: 'Não'
          },
        ],
      }
    },
    created() {
      this.carregaChamados();
    },
    methods: {
      async carregaChamados() {
        this.carregando = true
        try {
          this.agendamentos       = await api.get('agendamento')
        } catch (err) {
          console.error(err)
          this.message.error("Erro ao carregar chamados")
        } finally {
          this.carregando = false
        }
        console.log('CHAMADOS', this.agendamentos)
      },
      mostrarModalNovo() {
        this.abrirModalNovo = !this.abrirModalNovo
      },
      mostrarModalLogs() {
        this.abrirModalLogs = !this.abrirModalLogs
      },
      toggleIgnorados() {
        this.mostrarIgnorados = !this.mostrarIgnorados;
      },
      onUploadFinish({ file, event }) {
        const response = JSON.parse(event.target.response)
        console.log(response)
        this.Logs = response;
        this.message.success(`Arquivo ${file.name} enviado com sucesso!`)
        this.carregaChamados();
        this.mostrarModalLogs()
      },
      onUploadError({ file, event }) {
        this.message.error(`Erro ao enviar ${file.name}`)
        console.error('Erro:', event)
      },
      async salvarChamado() {
        // Aqui você envia os dados para sua API
        try {
          const payload = {
            cd_agendamento : this.cd_agendamento,
            nm_responsavel : this.nm_responsavel,
            cd_status_visita : this.cd_status_visita,
            cd_tipo_loja : this.cd_tipo_loja,
            cd_equipamentos : this.cd_equipamentos,
            cd_beacon : this.cd_beacon,
            dt_chamado : this.dt_chamado,
            nivel_sinal : this.nivel_sinal,
          }
          await api.post('chamado', payload)
          this.message.success("Chamado criado com sucesso")
          this.mostrarModalNovo()
          this.carregaChamados()
        } catch (err) {
          console.error(err)
          this.message.error("Erro ao salvar chamado")
        }
      }
    }
  }
  </script>
  
  <style scoped>
  /* ====== Layout geral ====== */
  .p-4 {
    padding: 1.5rem;
  }
  
  .mb-4 {
    margin-bottom: 1.5rem;
  }
  
  .flex {
    display: flex;
  }
  
  .justify-between {
    justify-content: space-between;
    align-items: center;
  }
  
  .justify-end {
    justify-content: flex-end;
    align-items: center;
  }
  
  .gap-2 {
    gap: 0.75rem;
  }
  
  .mt-4 {
    margin-top: 1.25rem;
  }
  
  /* ====== Botões ====== */
  .n-button {
    transition: all 0.2s ease-in-out;
  }
  
  .n-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
  
  /* ====== Cartão principal ====== */
  .n-card {
    border-radius: 16px !important;
  }
  
  /* ====== Tabela ====== */
  .n-data-table {
    border-radius: 12px;
    overflow: hidden;
  }
  
  .n-data-table ::v-deep(.n-data-table-th) {
    font-weight: 600;
  }
  
  .n-data-table ::v-deep(.n-data-table-td) {
    padding: 0.8rem 1rem !important;
    font-size: 0.95rem;
  }
  
  /* ====== Modal ====== */
  .n-modal {
    border-radius: 16px !important;
    background: #fff;
    padding: 1.5rem;
  }
  
  .n-modal ::v-deep(.n-dialog__title) {
    font-size: 1.3rem;
    font-weight: 600;
    color: #222;
  }
  
  /* ====== Grid do formulário ====== */
  .grid {
    display: grid;
  }
  
  .grid-cols-2 {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .gap-4 {
    gap: 1.25rem;
  }
  
  /* ====== Campos de entrada ====== */
  .n-input,
  .n-date-picker {
    width: 100%;
  }
  
  .n-input ::v-deep(input),
  .n-date-picker ::v-deep(input) {
    border-radius: 10px !important;
    padding: 10px 14px !important;
  }
  
  /* ====== Botões do modal ====== */
  .modal-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 1.5rem;
    gap: 1rem;
  }
  
  /* ====== Animações sutis ====== */
  .n-card,
  .n-modal {
    transition: all 0.3s ease-in-out;
  }
  
  .n-modal[show="true"] {
    transform: scale(1.02);
  }
  
  button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }  
  .log-card {
  background-color: #1e1e2f;
  color: #f1f1f1;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  margin: 20px auto;
  border: 1px solid #2c2c3e;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.log-card h2 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #4da3ff;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.log-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 6px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.label {
  font-weight: 500;
  color: #cfcfcf;
}

.value {
  font-weight: 600;
  color: #ffffff;
}

.value.ignored {
  color: #f1c40f;
}

.value.inserted {
  color: #2ecc71;
}

.log-item:last-child {
  border-bottom: none;
}

.ignored-list {
  background-color: #2b2b3f;
  border-radius: 12px;
  margin: 10px 0 16px;
  padding: 10px;
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.ignored-item {
  background-color: #3a3a50;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;
  transition: background-color 0.2s;
}

.ignored-item:hover {
  background-color: #4a4a65;
}

.ignored-header {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  font-weight: 600;
  color: #f1c40f;
  margin-bottom: 4px;
}

.ignored-text {
  font-size: 0.85rem;
  color: #e0e0e0;
  white-space: pre-wrap;
}
  </style>